import React, { memo } from 'react'
import map from 'ramda/src/map'
import withStyles from '@material-ui/core/styles/withStyles'
import Terms from 'root/src/client/web/base/StaticLayout'
import styles from './style'
import pageContent from './pageContent'

const PrivacyPolicy = memo(({ classes }) => (
	<Terms>
		<h1 style={{
			marginBottom: 60,
			textAlign: 'center',
		}}
		>Rules for Creators
		</h1>
		{map(({ id, text }) => (
			<section className={classes.section} id={id} key={text}>
				{text}
			</section>
		), pageContent(classes))}
	</Terms>
))

export default withStyles(styles, { name: 'MuiPrivacyPolicy' })(PrivacyPolicy)
